<div class="main-container">
	<div class="header">
		<h3 class="photos-nav">
			Photos
		</h3>
		<div class="filter-container">
			<div class="filter-search">
				<mat-form-field>
					<mat-label>Search</mat-label>
					<input matInput [ngModel]="search" (ngModelChange)="onSearchChange($event)">
				</mat-form-field>
			</div>
			<div class="filter-item">
				<mat-form-field class="calendar">
					<mat-label>From</mat-label>
					<input matInput [matDatepicker]="fromPicker" [max]="toDate" [ngModel]="fromDate"
						(ngModelChange)="onFromDateChange($event)">
					<mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
					<mat-datepicker #fromPicker></mat-datepicker>
					<button style="width: 20px;" mat-button *ngIf="fromDate" matSuffix mat-icon-button
						aria-label="Clear" (click)="onFromDateChange(null)">
						<mat-icon>close</mat-icon>
					</button>
				</mat-form-field>
			</div>
			<div class="filter-item">
				<mat-form-field class="calendar">
					<mat-label>To</mat-label>
					<input matInput [matDatepicker]="toPicker" [min]="fromDate" [ngModel]="toDate"
						(ngModelChange)="onToDateChange($event)">
					<mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
					<mat-datepicker #toPicker></mat-datepicker>
					<button style="width: 20px;" mat-button *ngIf="toDate" matSuffix mat-icon-button aria-label="Clear"
						(click)="onToDateChange(null)">
						<mat-icon>close</mat-icon>
					</button>
				</mat-form-field>
			</div>
		</div>
	</div>

	<div class="photos-wrapper">
		<div class="photos-list">
			<p class="empty-message-container" *ngIf="filteredPhotos.length === 0">There are no photos.</p>
			<div class="photo-container" (click)="onOpenPhotoDetails(photo)" *ngFor="let photo of filteredPhotos">
				<div class="thumbnail" (click)="loadPhotoPreview(photo, $event)">
					<img [class.no-thumbnail]="!photo.thumbnail" [src]="imageThumnail(photo)" />
					<div class="preview-overlay">
						<mat-icon>visibility</mat-icon>
					</div>
				</div>
				<div class="details">
					<div class="details-grid">
						<div class="item-label">Date:</div>
						<div class="item-details">{{formatDate(photo.createdOn)}}</div>
						<div class="item-label">Field:</div>
						<div class="item-details">
							<div class="field-name" [matTooltip]="photo.digitalLogFormField" style="font-size: 16px;">{{photo.digitalLogFormField}}</div>
							<div class="section-name" [matTooltip]="getSectionName(photo.digitalLogFormFieldId)" style="font-size: 14px;">{{getSectionName(photo.digitalLogFormFieldId)}}</div>
							<div class="group" [matTooltip]="getGroupName(photo.digitalLogFormFieldId)">{{getGroupName(photo.digitalLogFormFieldId)}}</div>	
						</div>
						<div class="item-label">Notes:</div>
						<div class="item-details">{{photo.note}}</div>
					</div>
				</div>
				<div class="delete-action">
					<button mat-icon-button title="Delete"
						(click)="deleteConfirmationModal.open(photo); $event.stopPropagation();">
						<mat-icon>delete</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="actions-container md-view">
	<ng-container>
		<action-button [icon]="ButtonIcons.AddPhoto" [name]="'Add Photos'"
			(click)="onClickAddPhoto(fileInput)"></action-button>
	</ng-container>
</div>

<generic-modal #photoDetailsModal class="photo-details-modal" [hideOnBackdropClick]="false">
	<ng-template #modalBody let-photo="data">
		<div class="photo-wrapper">
			<img [class.no-thumbnail]="!photo.thumbnail" [src]="imageThumnail(photo)" />
		</div>
		<div class="photo-field">
			<mat-form-field appearance="fill"> 
				<mat-label>Related Field</mat-label>
				<mat-select [(value)]="photo.updatedDigitalLogFormFieldId" [disabled]="!!photo.isDigitalLogFormFieldLocked">
				  <mat-optgroup *ngFor="let group of availableGroupedDigitalLogFormFields" [label]="group.digitalLogFormGroupName">
					<mat-option *ngFor="let field of group.digitalLogFormFields" [value]="field.id">
						<div class="field">
							<span class="group-name" *ngIf="group?.digitalLogFormGroupId">
								{{group.digitalLogFormGroupName}}
							</span>
							<span *ngIf="!!field?.conditionalName" style="font-size: 14px;" class="section-name">
								{{field.conditionalName}}
							</span>
							<span style="font-size: 16px;">
								<b>{{field.fieldName}}</b>
							</span>
						</div>
					</mat-option>
				  </mat-optgroup>
				</mat-select>
			  </mat-form-field>
		</div>
		<div class="photo-notes">
			<mat-form-field>
				<mat-label>Notes</mat-label>
				<textarea rows="5" matInput [(ngModel)]="photo.updatedNote"
					placeholder="Enter notes here..."></textarea>
			</mat-form-field>
		</div>
	</ng-template>

	<ng-template #modalActions let-data="data">
		<button mat-raised-button class="secondary" type="button" (click)="photoDetailsModal.hide()">Cancel</button>
		<button mat-raised-button type="button" class="primary"
			(click)="onSavePhotoDetails(data); photoDetailsModal.hide()">Save</button>
	</ng-template>
</generic-modal>

<generic-modal #deleteConfirmationModal>
	<ng-template #modalHeading let-data="data">
		<strong>Delete confirmation</strong>
	</ng-template>
	<ng-template #modalBody let-data="data">
		<div class="main-container">
			<p>
				Are you sure you want to delete this photo?
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions let-data="data">
		<button mat-flat-button class="primary" (click)="onDeletePhotoConfirmed(data);"
			[disabled]="isDeleteDisabled">Confirm</button>
		<button mat-flat-button (click)="deleteConfirmationModal.hide()">Cancel</button>
	</ng-template>
</generic-modal>

<generic-modal #addPhotosConfirmationModal class="add-photos-modal">
	<ng-template #modalHeading let-data="data">
		<strong>Photo Upload Warning</strong>
	</ng-template>
	<ng-template #modalBody let-data="data">
		<div class="main-container">
			<div class="info-message">
				{{addPhotosMessage}}
			</div>
			<p>
				<strong>Are you sure you want to proceed?</strong>
			</p>
		</div>
	</ng-template>
	<ng-template #modalActions let-data="data">
		<button mat-flat-button class="primary" (click)="onAddPhotosConfirmed(data);"
			[disabled]="isPhotosSaving">Yes</button>
		<button mat-flat-button (click)="addPhotosConfirmationModal.hide()">No</button>
	</ng-template>
</generic-modal>

<input type="file" name="photos-input" hidden #fileInput (change)="onChangePhotos($event.target.files, fileInput)"
	multiple="multiple" accept=".jpg, .jpeg, .png" />

<generic-modal #photoPreviewModal [isFullHeight]="true" [overlayClass]="'photo-preview-modal'" [hideOnBackdropClick]="false" [onHide]="onPhotoPreviewModalHide">
	<ng-template #modalBody>
		<div class="photo-preview-content">
			<ng-container *ngIf="selectedDocumentDetails">
				<app-document-viewer #photoPreviewViewer class="photo-preview-viewer" [documentDetails]="selectedDocumentDetails"
					[afterWebViewerRender]="onPhotoPreviewViewerRendered">
				</app-document-viewer>
			</ng-container>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<button mat-flat-button (click)="photoPreviewModal.hide()">Close</button>
	</ng-template>
</generic-modal>